import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FormOutlined, EyeOutlined } from '@ant-design/icons';
import { Table, Row, Col, Breadcrumb, Typography, Tooltip, Modal } from 'antd';
import { intialPaginationState, showingPageTotalRange, filter } from '../../../common_functions';

const GeoLocList = props => {
  const [locations, setLocations] = useState([]);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);
  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: 'State',
      dataIndex: 'state',
      key: 'state',
      sorter: true,
      render: (text, record) => <span style={{ textTransform: 'capitalize' }}>{!!record.state && record.state.state}</span>,
      ...filter('state'),
    },
    {
      title: 'Park',
      dataIndex: 'park',
      key: 'park',
      sorter: true,
      render: (text, record) => <span style={{ textTransform: 'capitalize' }}>{!!record.park && record.park.park}</span>,
      ...filter('park'),
    },
    {
      title: 'TGN ID 1',
      dataIndex: 'tgn_id_1',
      key: 'tgn_id_1',
      sorter: true,
      ...filter('tgn_id_1'),
    },
    {
      title: 'Prominent Natural Features',
      dataIndex: 'prominent_natural_features',
      key: 'prominent_natural_features',
      sorter: true,
      ...filter('prominent_natural_features'),
    },
    {
      title: 'Latitude',
      dataIndex: 'latitude',
      key: 'latitude',
      sorter: true,
      ...filter('latitude'),
    },
    {
      title: 'Longitude',
      dataIndex: 'longitude',
      key: 'longitude',
      sorter: true,
      ...filter('longitude'),
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            <Link to={'/settings/geographic-locations/' + record.id}>
              <Tooltip
                placement="top"
                title={props.roleType === 'admin' || props?.tabs_permissions?.settings_geographic_locations?.edit ? 'Edit' : 'View'}
              >
                <button className="edit-btn">
                  {props.roleType === 'admin' || props?.tabs_permissions?.settings_geographic_locations?.edit ? (
                    <FormOutlined />
                  ) : (
                    <EyeOutlined />
                  )}
                </button>
              </Tooltip>
            </Link>
            {props.deleteRecord(
              props,
              record.id,
              'geographic_locations',
              'Geographic location?',
              locations,
              setLocations,
              props?.tabs_permissions?.settings_geographic_locations?.delete
            )}
          </div>
        </span>
      ),
    },
  ];
  //Get collection data
  useEffect(() => {
    (async () => {
    await getLocationsData(pagination);
  })();
  }, []);

  const getLocationsData = async (pagination, filters = {}, sorter = '') => {
    try {
      setLoading(true);
      const response = await props.getItems('geographic_locations', {
        fields: ['id', 'state.state', 'park.park', 'prominent_natural_features', 'latitude', 'longitude', 'tgn_id_1'],
        sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
        filters: filters,
        offset: pagination.pageSize * (pagination.current - 1),
        limit: pagination.pageSize,
        meta: 'filter_count',
      });
      pagination.total = response.meta.filter_count;
      setPagination(pagination);
      setLocations(response.data);
    } catch (error) {
      Modal.warning({
        title: 'Error',
        content: 'Unexpected error occured',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = async (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorter(sorter);
    setLoading(true);
    let filtersitems = {};
    for (let key in filters) {
      if (filters.hasOwnProperty(key)) {
        let val = filters[key];
        if (!!val) {
          filtersitems[key] =
            key == 'id'
              ? { _eq: val[0] }
              : key == 'state'
              ? { state: { _icontains: val[0] } }
              : key == 'park'
              ? { park: { _icontains: val[0] } }
              : { _icontains: val[0] };
        }
      }
    }
    await getLocationsData(pagination, filtersitems, sorter);
  };
  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Settings", href: "/settings/geographic-locations" }, { title: "Geographic Locations" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                View Geographic Locations
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              {props.createButton(
                props.roleType,
                props.tabs_permissions.settings_geographic_locations,
                `/settings/geographic-locations/new`,
                'Create Geographic Location'
              )}
            </Col>
          </Row>
          <hr />
          <div className="artist-list">
            <Table
              scroll={{ x: 'max-content' }}
              columns={columns}
              bordered
              rowKey={record => record.id}
              dataSource={locations}
              pagination={{ ...pagination, ...showingPageTotalRange }}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default GeoLocList;
